module.exports = __webpack_public_path__ + "static/media/WritingPencil.1ddf68cc.svg";